import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers";
import { useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

export const WebsiteBuilderNotice = () => {
  const history = useHistory();
  const { onExit } = useCustomizeUIData();

  const handleGiveItATry = () => {
    onExit();
    history.push(settingsNavPathV3.content.pages);
  };

  return (
    <div className="flex flex-col gap-2 rounded-lg border border-[#FDE68A] bg-[#FEF3C7] p-4">
      <Typography.LabelMd weight="semibold">
        {t("courses.lockscreen.website_builder_notice.title")}
      </Typography.LabelMd>
      <Typography.BodySm>
        {t("courses.lockscreen.website_builder_notice.description")}
      </Typography.BodySm>
      <Button
        type="button"
        onClick={handleGiveItATry}
        variant="secondary"
        className="mt-1 self-start"
      >
        {t("courses.lockscreen.website_builder_notice.button")}
      </Button>
    </div>
  );
};
